import { HeroUIProvider, type HeroUIProviderProps } from '@heroui/react';

import { ToastProvider, type ToastProviderProps } from './Toast';

export type ThemeProviderProps = {
  children: React.ReactNode;
  providerProps?: Exclude<HeroUIProviderProps, 'children'>;
  toasterProps?: Exclude<ToastProviderProps, 'children'>;
};

export const ThemeProvider = ({
  children,
  providerProps,
  toasterProps,
}: ThemeProviderProps) => {
  return (
    <HeroUIProvider {...providerProps}>
      <ToastProvider {...toasterProps} />
      {children}
    </HeroUIProvider>
  );
};
